import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import RulesPage from './pages/RulesPage';
import DashboardPage from './pages/DashboardPage';
import BetPage from './pages/BetPage';
import PaymentPage from './pages/PaymentPage';
import RankingPage from './pages/RankingPage';
import PixPage from './pages/PixPage';
import AdminPage from './pages/admin/AdminPage';
import Layout from './components/Layout';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function RequireAdmin({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/regulamento" element={<RulesPage />} />
        <Route path="/pix" element={<PixPage />} />
        <Route path="/ranking/:roundId" element={<RankingPage />} />
        <Route path="/bet/:betId" element={<BetPage />} />
        <Route path="/bet/:betId/pagamento" element={<PaymentPage />} />
      </Route>
      <Route
        path="/admin/*"
        element={
          <RequireAdmin>
            <AdminPage />
          </RequireAdmin>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
